export default __webpack_public_path__ + "static/media/music.9554da8d.mp3";